/**
 *  Function to compare two dates. Parameters must both be Dates or ISO8601 date strings
 */
export const compareDates = function (a: string | Date, b: string | Date): number {
    if (typeof a !== typeof b) {
        throw new Error("Incomparable Types");
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime() ? 0 : a > b ? -1 : 1;
    }
    return a === b ? 0 : a > b ? -1 : 1;
};
